import React from 'react'
import { ComponentExt } from '@utils/reactExt'
import wenxinyiyan from "@assets/img/ai/wenxinyiyan.png"
import tongyiqianwen from "@assets/img/ai/tongyiqianwen.png"
import kimi from "@assets/img/ai/kimi.png"
import * as styles from "./style/index.scss"
import { userStore } from '@src/store';

export default class AiZoneHistory extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            chatMsgLogData: []
        }
    }
    async componentDidMount() {
        if (!sessionStorage.getItem('openid')) {
            this.goToPath('/AiZone')
        }
        document.title = '历史对话'
        this.$toast.loading('获取数据，请稍等', 15)
        const res = [] = await this.api.getChatMsgLog({ openId: sessionStorage.getItem('openid'), apiTypes: ['2', '3', '4'] })
        this.$toast.hide()
        console.log("res", res)
        this.setState({ chatMsgLogData: res })
    }
    imgData = { "2": kimi, '3': tongyiqianwen, '4': wenxinyiyan }
    click = async () => {
        this.$toast.loading('清空历史对话，请稍等', 15)
        await this.api.delLog({ openId: sessionStorage.getItem('openid') })
        const res = [] = await this.api.getChatMsgLog({ openId: sessionStorage.getItem('openid'), apiTypes: ['2', '3', '4'] })
        this.$toast.hide()
        this.setState({ chatMsgLogData: res })
    }
    showDetail = (apiType, id) => {
        this.goToPath(`/AiZone?showHistory=1&apiType=${apiType}&id=${id}`)
    }
    render() {
        return (
            <div className={styles.AiZoneHistory}>
                {this.state.chatMsgLogData.length > 0 && (
                    this.state.chatMsgLogData.map((item, index) => {
                        return <div className={styles.logBox} key={index} onClick={() => this.showDetail(item.apiType, item.id)}>
                            <img src={this.imgData[item.apiType]} className={styles.logBoxImg} alt="" />
                            <div className={styles.logBoxText}>{item.question}</div>
                        </div>
                    })
                )}
                <div className={styles.clearData} onClick={this.click}>
                    <div className={styles.clearbutton}>清空历史对话</div>
                </div>
            </div>
        )
    }
}
